import PropTypes from 'prop-types'
import React from 'react'

const CircleLoader = ({ size, extendClass }) => (
  <span className={'circle-loader-wrap ' + extendClass}>
    <svg className="circle-loader" width={size} height={size}>
      <circle cx={size / 2} cy={size / 2} r={size / 4} />
    </svg>
  </span>
)

CircleLoader.propTypes = {
  size: PropTypes.number,
  extendClass: PropTypes.string
}

CircleLoader.defaultProps = {
  size: 30
}

export default CircleLoader
